<template>
  <div class="container">
    <section class="section-1">
      <div class="row mb-4">
        <div class="col-md-3 supplier-info">
          <div class="profile-block">
            <ContentLoader v-if="!isSupplierDataLoaded" />
            <SupplierInfo
              :supplier="supplierDetails"
              v-else
              :icon-color="'#fff'"
              :text-color="'#fff'"
            />
          </div>
        </div>
        <div class="col-md-9">
          <Tabs :tabs="tabs" v-model="tab" />
          <div class="tab-pane container px-0 my-2 active">
            <ContentLoader v-if="!currentTabComponent.data" />
            <component
              v-bind:is="currentTabComponent.component"
              :data="currentTabComponent.data"
              class="tab"
              v-else
            ></component>
          </div>
        </div>
      </div>
    </section>
    <hr />
    <section class="section-2">
      <h2 class="mb-4">{{ translate('products.title') }}</h2>
      <ContentLoader
        v-if="!isSupplierDataLoaded && !supplierDetails.products.length"
      />
      <div class="row" style="width: 100%">
        <ProductBoxSm
          class="mb-3"
          v-for="item in supplierDetails.products"
          :key="item.id"
          :product="item"
          @click.native="
            $router.push({ name: 'product', params: { id: item.id } })
          "
        />
      </div>
      <NoData
        v-if="isSupplierDataLoaded && !supplierDetails.products.length"
        :message="translate('fallback-messages.no_data_found')"
      />
    </section>
  </div>
</template>

<script>
import {
  getSupplier,
  getSupplierServices,
  getSupplierDetails
} from '@/api/services/supplier'
import Tabs from '@/components/Tabs'
import ProductBoxSm from '@/components/product/ProductBoxSm'
import About from '@/components/supplier/tabs/About'
import Vision from '@/components/supplier/tabs/Vision'
import Team from '@/components/supplier/tabs/Team'
import Services from '@/components/supplier/tabs/Services'
import SupplierInfo from '@/components/sharable/SupplierInfo'

export default {
  name: 'Supplier',
  components: { ProductBoxSm, Tabs, SupplierInfo },
  props: {
    id: {
      required: true,
      type: String | Number
    }
  },
  data() {
    return {
      supplierServices: {},
      supplierDetails: {
        products: []
      },
      tab: 0,
      products: [],
      isSupplierDataLoaded: false
    }
  },
  computed: {
    tabs() {
      return [
        {
          title: this.translate('suppliers.about'),
          component: About,
          data: this.supplierDetails.about_us
        },
        {
          title: this.translate('suppliers.vision'),
          component: Vision,
          data: this.supplierDetails.our_vision
        },
        {
          title: this.translate('suppliers.team'),
          component: Team,
          data: this.supplierDetails.our_team
        },
        {
          title: this.translate('suppliers.services'),
          component: Services,
          data: this.supplierServices
        }
      ]
    },
    currentTabComponent() {
      return this.tabs[this.tab]
    }
  },
  async mounted() {
    await this.getSupplier()
    await this.getSupplierDetails()
    await this.getSupplierServices()
    this.isSupplierDataLoaded = true
  },
  methods: {
    async getSupplier() {
      let { data } = await getSupplier(this.id)
      this.supplierDetails = { ...this.supplierDetails, ...data }
    },
    async getSupplierDetails() {
      let { data } = await getSupplierDetails(this.id)
      this.supplierDetails = { ...this.supplierDetails, ...data }
    },
    async getSupplierServices() {
      let { data } = await getSupplierServices(this.id)
      this.supplierServices = data
    }
  }
}
</script>

<style lang="scss">
.profile-block {
  position: relative;
  overflow: hidden;
  .user-heading {
    background: #ff9a22 none repeat scroll 0 0 !important;
  }
}
@media (min-width: 320px) {
  .supplier-info {
    margin-bottom: 20px;
  }
}
</style>